module.exports = __webpack_public_path__ + "static/img/price.60de538.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-2/price.png
// module id = RMD0
// module chunks = 0